import React from "react";
import { reels } from "../data/gallery";
import { BandhaniField, BlockBand } from "./Decor";
import { GiCutDiamond } from "react-icons/gi";

export default function Reels() {
  return (
    <section id="showcase" className="relative overflow-hidden bg-coffee-900 py-20 text-cream md:py-28">
      <BandhaniField className="absolute inset-0 text-gold" opacity={0.05} />
      <BlockBand className="absolute left-0 top-0 h-5 w-full text-gold/40" flip />

      <div className="container-x relative">
        <div className="text-center">
          <span className="eyebrow !text-gold">In Motion</span>
          <h2 className="mt-2 font-display text-3xl text-gold-light sm:text-4xl">Showroom Reels</h2>
          <div className="mt-3 flex justify-center text-gold">
            <span className="h-px w-16 self-center bg-gradient-to-r from-transparent to-gold" />
            <GiCutDiamond className="mx-3 self-center text-base" />
            <span className="h-px w-16 self-center bg-gradient-to-l from-transparent to-gold" />
          </div>
          <p className="mx-auto mt-4 max-w-xl text-cream/80">
            A closer look at our latest arrivals and showroom highlights — hover or tap to play.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
          {reels.map((r) => (
            <div
              key={r.id}
              className="reveal group relative aspect-[9/16] overflow-hidden rounded-lg border border-gold/60 bg-black shadow-vintage"
            >
              <span className="absolute left-2.5 top-2.5 z-10 inline-flex items-center gap-1.5 rounded-full border border-gold/70 bg-coffee-950/80 px-2.5 py-0.5 text-[0.6rem] uppercase tracking-wider text-gold-light">
                <span className="h-1.5 w-1.5 rounded-full bg-gold-light" /> Reel
              </span>
              <video
                src={r.src}
                muted
                loop
                playsInline
                preload="metadata"
                className="h-full w-full object-cover"
                onMouseEnter={(e) => e.currentTarget.play()}
                onMouseLeave={(e) => { e.currentTarget.pause(); e.currentTarget.currentTime = 0; }}
                onClick={(e) => (e.currentTarget.paused ? e.currentTarget.play() : e.currentTarget.pause())}
              />
              <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-gold/20" />
            </div>
          ))}
        </div>
      </div>

      <BlockBand className="absolute bottom-0 left-0 h-5 w-full text-gold/40" />
    </section>
  );
}
